import {handleActions} from 'redux-actions'
import * as ActionTypes from './actionTypes'

const initialState = {
    price: 0,
    pricePerTimeInterval: 0,
    discount: 0,
    purchasePeriod: 1,
    startDate: new Date(),
    endDate: new Date(),
    currentUsersCountSelected: 1,
    unlimited: false,
}

export default handleActions({
    [ActionTypes.DISCOUNT_SET]: (state, {payload: discount}) => ({
        ...state,
        discount,
    }),
    [ActionTypes.PURCHASE_INFO_SET]: (state, {payload: loadData}) => ({
        ...state,
        price: loadData.price,
        discount: loadData.yearlyDiscount,
        startDate: Date.parseJSONDate(loadData.startDate),
        endDate: Date.parseJSONDate(loadData.endDate),
        pricePerTimeInterval: loadData.pricePerUser,
    }),
    [ActionTypes.PRICE_PER_TIME_INTERVAL_SET]: (state, {payload: pricePerTimeInterval}) => ({
        ...state,
        pricePerTimeInterval: pricePerTimeInterval,
    }),
    [ActionTypes.PRICE_SET]: (state, {payload: price}) => ({
        ...state,
        price,
    }),
    [ActionTypes.PURCHASE_PERIOD_SET]: (state, {payload: purchasePeriod}) => ({
        ...state,
        purchasePeriod,
    }),
    [ActionTypes.START_DATE_SET]: (state, {payload: startDate}) => ({
        ...state,
        startDate,
    }),
    [ActionTypes.END_DATE_SET]: (state, {payload: endDate}) => ({
        ...state,
        endDate,
    }),
    [ActionTypes.USERS_COUNT_SET]: (state, {payload: currentUsersCountSelected}) => ({
        ...state,
        currentUsersCountSelected,
    }),
    [ActionTypes.UNLIMITED_SET]: (state, {payload: unlimited}) => ({
        ...state,
        unlimited,
    }),
}, initialState)


// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/chooser/reducer.js